
import TabBar from '@/components/follow/TabBar.vue';
import Avatar from './Avatar.vue';
import Analyst from './Analyst.vue';
import Mechanism from './Mechanism.vue';
import OuterResearch from './OuterResearch.vue';
import Swiper from 'swiper';
import CommonError from '@/components/common/CommonError.vue';
import CommonLoad from '@/components/common/CommonLoad.vue';
import {
  getRankIndustryList,
  getFollowAuthor,
  getFollowOrg,
  getFollowIndustry,
  getOrgRank,
  getRankAuthor,
  getReport,
} from '@/apis/index';
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import {
  SCROLL_TIMEOUT,
  AVATAR_URL,
  tabItems,
  MAGIC_TWO,
  THROTTLE_TIME,
  DELAY_TIME,
  STAT,
  URLVER,
} from '@/config/config';
import { throttle, getHangqing, getReadCount } from '@/utils/tools';

@Component({
  components: {
    TabBar,
    Avatar,
    Analyst,
    Mechanism,
    OuterResearch,
    CommonError,
    CommonLoad,
  },
})
export default class Follow extends Vue {
  @Prop() private activeTabIndex!: number;
  @Prop() private slide!: number;
  //是否显示加载中
  showLoad = false;
  //关注类型tab
  tabItems = tabItems;
  //头像
  AVATAR_URL = AVATAR_URL;
  //滚动加载的最后一个研报的seq
  lastSeq = null;
  //获取关注研报
  idList = '';
  //不再进行滚动加载
  stopReq = false;
  reportList = [];
  swiper: any = null;
  mechanism = [];
  list = [];
  industry = [];
  swiperIndex = 0;
  avatarList = [];
  mechanismList = [];
  industryList = [];
  total = 20;
  listIsLoading = false;
  listFinished = false;
  scrollTop = 0;
  clientHeight = 0;
  scrollHeight = 0;
  showNoMore = false;
  showLoading = false;
  str = '';
  //接口加锁
  lock = false;
  ifPeriod = null;
  isActived = false;
  //滚动加载底部状态栏是否可见
  tipShow = false;
  //分页页数
  pages = 0;
  @Watch('swiperIndex')
  onIndexChange(val: number) {
    this.pages = 0;
    if (val === 0) {
      this.getFollow();
    } else if (val === 1) {
      this.getFollowOrg();
    } else {
      this.getFollowInd();
    }
  }
  @Watch('activeTabIndex')
  onActiveTabIndexChanged(newValue: number) {
    // eslint-disable-next-line sonarjs/no-collapsible-if
    if (newValue === 1 + this.slide) {
      if (
        (this.avatarList.length === 0 && this.mechanismList.length === 0 && this.industryList.length === 0) ||
        !this.isActived
      ) {
        this.activeComp();
      }
      this.isActived = true;
    }
  }
  @Watch('reportList')
  onReportListChange() {
    if (this.reportList.length === 0) {
      this.tipShow = false;
    } else {
      this.tipShow = true;
    }
  }
  //接口异常时刷新
  refresh() {
    this.activeComp();
  }
  format() {
    const ifStyle =
      // eslint-disable-next-line thsjs/expression-complexity
      this.avatarList.length === 0 &&
      this.mechanismList.length === 0 &&
      this.industryList.length === 0 &&
      this.list.length === 0 &&
      this.mechanism.length === 0 &&
      this.industry.length === 0;
    if (ifStyle && window.getCssStyle() === 'white') {
      return {
        background: '#ffffff',
      };
    } else if (ifStyle && window.getCssStyle() === 'black') {
      return {
        background: '#1c1c1c',
      };
    } else {
      return '';
    }
  }
  getDeep(deep: number) {
    this.pages = 0;
    this.stopReq = false;
    window.scrollTo(0, 0);
    getReport({
      report_type: 'follow_all',
      is_deep: deep,
    }).then(res => {
      this.dealResData(res);
    });
  }
  clickTab(item: object, value: number) {
    this.swiperIndex = value;
    if (value === 0) {
      window.hxmPageStat(`${STAT.follow}.fenxishi`, URLVER);
    } else if (value === 1) {
      window.hxmPageStat(`${STAT.follow}.jigou`, URLVER);
    } else {
      window.hxmPageStat(`${STAT.follow}.hangye`, URLVER);
    }
  }
  changeStatus(index: number) {
    if (index === 0) {
      this.getFollow();
    } else if (index === 1) {
      this.getFollowOrg();
    } else {
      this.getFollowInd();
    }
  }
  handleListLoad() {
    setTimeout(() => {
      // 加载结束将listIsLoading设置为false，否则再次滑到底部将不再触发load
      this.listIsLoading = false;
      if (this.reportList.length >= this.total) {
        // 加载全部数据后将listFinished设置为true，将不再触发load
        this.listFinished = true;
      } else {
        this.mergeList();
      }
    }, SCROLL_TIMEOUT);
  }
  //滚动加载
  mergeList() {
    const deep = window.sessionStorage.getItem('deep') ? Number(window.sessionStorage.getItem('deep')) : null;
    getReport({
      page: this.pages,
      report_type: 'follow_all',
      seq: this.lastSeq,
      is_deep: deep ? deep : null,
    }).then(res => {
      this.reportList = [...this.reportList, ...res.data.list];
      if (res.data.list.length > 0) {
        this.lastSeq = res.data.list[res.data.list.length - 1].seq;
        this.showNoMore = false;
        this.getReadCount(res.data.list);
        this.getHangqing(res);
      } else {
        this.stopReq = true;
        this.showNoMore = true;
        this.showLoading = false;
      }
    });
  }
  dealResData(res: any) {
    this.reportList = res.data.list;
    if (res.data.list.length > 0) {
      this.lastSeq = res.data.list[res.data.list.length - 1].seq;
      this.getReadCount(res.data.list);
      this.getHangqing(res);
    }
  }
  //拼接获取阅读量的参数
  getReadCount(LIST: Array<object>) {
    getReadCount(this, LIST);
  }
  getScrollHeight() {
    return Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
  }
  //滚动加载列表
  scrollLoading() {
    this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;
    this.clientHeight = document.body.clientHeight || document.documentElement.clientHeight;
    const SCROLL_BIAS = 10;
    if (this.scrollTop + this.clientHeight + SCROLL_BIAS >= this.getScrollHeight()) {
      const ifPopup = Number(window.sessionStorage.getItem('popShow'));
      if (!this.stopReq && this.activeTabIndex === 1 + this.slide && !ifPopup) {
        this.pages++;
        this.showLoading = true;
        this.mergeList();
      } else {
        this.showNoMore = true;
        this.showLoading = false;
      }
    } else {
      this.showNoMore = false;
      this.showLoading = false;
    }
  }
  getList(seq: number, period: string, isDeep: number, idList: string) {
    this.reportList = [];
    //接口加锁
    const interval = setInterval(() => {
      if (!this.lock) {
        window.clearInterval(interval);
        this.lock = true;
        getReport({
          report_type: 'follow',
          seq,
          period,
          follow_id: idList,
          follow_type: this.swiperIndex,
          is_deep: isDeep,
        }).then(res => {
          this.reportList = res.data.list;
          this.lock = false;
          if (res.data.list.length > 0) {
            this.lastSeq = res.data.list[res.data.list.length - 1].seq;
            this.getReadCount(res.data.list);
            this.getHangqing(res);
          }
        });
      }
    }, THROTTLE_TIME);
  }
  getFollow() {
    getFollowAuthor('').then(res => {
      this.showLoad = false;
      const list = res.data.followList.slice(0, 10);
      window.sessionStorage.setItem('author', JSON.stringify(list));
      this.avatarList = list;
    });
  }
  getFollowOrg() {
    getFollowOrg('').then(res => {
      this.showLoad = false;
      const list = res.data.followList.slice(0, 10);
      window.sessionStorage.setItem('org', JSON.stringify(list));
      this.mechanismList = list;
    });
  }
  getFollowInd() {
    getFollowIndustry('').then(res => {
      this.showLoad = false;
      const list = res.data.followList.slice(0, 10);
      window.sessionStorage.setItem('industry', JSON.stringify(list));
      this.industryList = list;
    });
  }
  init() {
    // swiper 销毁更改
    if (this.swiper) {
      return;
    }
    this.swiper = new Swiper('#hotAnalyst', {
      freeMode: true,
      slidesPerView: 'auto',
      normalizeSlideIndex: false,
      observer: true,
      observeParents: true,
    });
  }
  //获取行情
  getHangqing(res: any) {
    getHangqing(res);
  }
  getRecommend() {
    //获取推荐分析师列表
    getRankAuthor({
      order_by: 1,
      type: '1y',
      start: 0,
      limit: 6,
    }).then(res1 => {
      const response = res1 as any;
      this.list = response.data.list;
      this.list.forEach(item => {
        this.$set(
          this.$followAuthorList,
          item.authorId,
          this.$followAuthorList.hasOwnProperty(item.authorId) ? this.$followAuthorList[item.authorId] : 1
        );
      });
    });
    //获取机构排名列表
    getOrgRank({
      type: '1y',
      order_by: 1,
      start: 0,
      limit: 6,
    }).then(res2 => {
      this.mechanism = res2.data.list;
      this.mechanism.forEach(item => {
        this.$set(
          this.$followOrgList,
          item.orgId,
          this.$followOrgList.hasOwnProperty(item.orgId) ? this.$followAuthorList[item.orgId] : 1
        );
      });
    });
    //获取行业排行
    getRankIndustryList({
      order_by: 1,
      type: 20,
      start: 0,
      limit: 6,
    }).then(res3 => {
      this.industry = res3.data.list;
      this.industry.forEach(item => {
        this.$set(
          this.$followIndustryList,
          item.industryId,
          this.$followIndustryList.hasOwnProperty(item.industryId)
            ? this.$followIndustryList[item.industryId]
            : 1
        );
      });
    });
  }
  activeComp() {
    this.showLoad = true;
    window.hxmPageStat(`${STAT.follow}`, URLVER);
    window.addEventListener(
      'scroll',
      throttle(() => this.scrollLoading(), THROTTLE_TIME),
      true
    );
    getReport({
      report_type: 'follow_all',
    }).then(res => {
      this.showLoad = false;
      this.reportList = res.data.list;
      if (res.data.list.length > 0) {
        this.lastSeq = res.data.list[res.data.list.length - 1].seq;
        this.showNoMore = false;
        this.getReadCount(res.data.list);
        this.getHangqing(res);
      } else {
        this.stopReq = true;
        this.showNoMore = true;
        this.showLoading = false;
      }
    });
    this.getFollowOrg();
    this.getFollowInd();
    getFollowAuthor('').then(res => {
      this.showLoad = false;
      const list = res.data.followList.slice(0, 10);
      window.sessionStorage.setItem('author', JSON.stringify(list));
      this.avatarList = res.data.followList.slice(0, 10);
      if (
        this.industryList.length === 0 &&
        this.mechanismList.length === 0 &&
        res.data.followList.length === 0
      ) {
        this.getRecommend();
      }
      setTimeout(() => {
        if (
          JSON.parse(window.sessionStorage.getItem('author')).length === 0 &&
          JSON.parse(window.sessionStorage.getItem('org')).length > 0
        ) {
          this.swiperIndex = 1;
        } else if (
          JSON.parse(window.sessionStorage.getItem('author')).length === 0 &&
          JSON.parse(window.sessionStorage.getItem('org')).length === 0 &&
          JSON.parse(window.sessionStorage.getItem('industry')).length > 0
        ) {
          this.swiperIndex = MAGIC_TWO;
        } else {
          return;
        }
      }, DELAY_TIME);
    });
    this.init();
  }
}
